module.exports = __webpack_public_path__ + "img/1594279255.1d154cb9.jpg";